<div class="loader-background" *ngIf="isLoading">
    <div class="loader-content">

        <img style="width:100%; height:auto" src="https://i.pinimg.com/originals/a0/02/a3/a002a3e51a2adc85d6c0a4684892e743.gif" />

    </div>
</div>